export const TARGET_BLANK = '_blank'
export const TARGET_SELF = '_self'

/**
 * Used on html element data-action to indicate a continue action
 * @type {string}
 */
export const DATA_ACTION_CONTINUE = 'continue'
